<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';
import { usePermissions } from '@/composables/usePermissions';

export default {
    page: {
        title: "ReCollect Listing",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            dtKey:0,
            key: '',
            title: "ReCollect Listing",
            items: [
                {
                    text: "Finance",
                    href: "/",
                },
                {
                    text: "Automate Collection",
                    href: "/",
                },
            ],

            list:[],
            sourceFile: '',
            loadingDetail:true,
            loadingUpload:false,
            ButtonSeen:true,
            PLG_filename:'',
        };
    },
  setup() {
        const permissions = usePermissions();
        
        return {
            permissions,
        };
    },
    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
            }
        },

        getlist(){
            this.loadingDetail = true;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'collection/retry')
            .then(response => {
                if (response) {
                    this.list = response.data.data;
                    this.dtKey +=1;
                }
            })
            // .catch(error => {
            // })
            .finally(() => {
                this.loadingDetail=false;
            });
        },

        downloadFileUrl: function (filepath) {
            location.href= process.env.VUE_APP_LOCAL_STORAGE+filepath;
        },

        downloadFile: function (item) {
            const posting_ = {         
                id: item.id,
            };

            axios.post(process.env.VUE_APP_API_BASEURL+'collection/retry/export', posting_, {responseType: 'blob'})
            .then(response => {
                if (response) {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', item.filename_after);
                    document.body.appendChild(fileLink);

                    fileLink.click();
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
            },

        submitFile(e)
        {                                  
            e.preventDefault();

            this.loadingUpload=true;
            let formData = new FormData();
            formData.append('file', this.sourceFile);
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL +'collection/retry/process-no-upload',formData)
            .then(() => {
                this.sourceFile = null;  
                this.$refs.uploadInput.value = null;              
                this.getlist();                  
            })
            .catch(error => {
                if(error.response?.data != undefined){
                    alert(error.response.data.message);
                }else{
                    alert('Something when wrong! Please try again.');
                }

            })
            .finally(() => {
                this.loadingUpload=false;
            });
        },

        handleFileUpload(event){
            this.sourceFile = event.target.files[0];
        },

        runCollection(id){            
            const result = confirm(`Are you sure to run this collection?`);
            if(result){
                this.loadingUpload=true;
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                axios.get(process.env.VUE_APP_API_BASEURL +'collection/run/' + id)
                .then(() => {
                    alert('Collection successfully run.');                   
                })
                .catch(error => {
                    this.messageBag = [error.error];
                    alert('Something when wrong! Please try again.');
                })
                .finally(() => {
                    this.loadingUpload=false;
                });
            }
        },
    },

    components: {
        Layout,
        PageHeader,
        DataTable,
    },

    mounted() {
        this.getlist();
    },
    
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="card">
            <div class="card-body">
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        
                        <div class="card-body border-bottom-dashed border-bottom">
                           
                            <form v-if="permissions.canCreate?.value" @submit="submitFile">
                                <div class="row g-3">
                                <div class="col-xl-6">                  
                                    <input class="form-control" type="file" v-on:change="handleFileUpload" 
                                    ref="uploadInput" accept=".xlsx, .xls, .csv" required>
                                </div>
                                <!--end col-->
                                <div class="col-xl-6">
                                <div class="row g-6">
                                    <div class="col-sm-4">
                                        <div v-if="loadingUpload" class="spinner-border text-success" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                        <button v-if="!loadingUpload" type="submit" class="btn btn-success w-100" :disabled="loadingUpload">
                                            <i class="ri-equalizer-fill me-2 align-bottom"></i>Upload
                                        </button>
                                        
                                    </div>

                                    <div class="col-sm-8">
                                    <div>
                                        
                                    </div>
                                    </div>
                                    <!--end col-->
                                </div>
                                </div>
                            </div>
                            </form>
                            <!--end row-->
                            
                            <br><br>
                        </div>
                        <div class="col-lg-12">
                            <div class="pt-4">
                                <h4 class="card-title">Collection File Listing</h4>                           
                            </div>
                            <div v-if='loadingDetail || loadingUpload'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-responsive">
                                <DataTable :options="{lengthChange: false}" :key="dtKey" class="table table-striped table-nowrap mb-0" id="example"> 
                                     <thead class="table-secondary">
                                        <tr>
                                            <th>No.</th>
                                            <th >Filename</th>      
                                            <th >Created Date</th>      
                                            <th >Created By</th>
                                            <th>Status</th>
                                            <th> Batch </th>
                                            <th v-if="permissions.canExport?.value" >Download</th>
                                            <!--th scope="col">Action</th-->
                                        </tr>
                                    </thead>

                                    <tbody>          
                                                     
                                        <tr v-for="(item, index) in list" :key="index" class="content">
                                            <td>{{ index+1 }}</td>                               
                                            <td>{{ item.filename_before }}</td>
                                            <td>{{ format_date(item.created_at) }}</td>
                                            <td>{{ item.user?.name }}</td>
                                            <td v-if="item.status == 1">Processed ({{ item.processed_batch_count }}/{{ item.batch_count }})</td>
                                            <td v-if="item.status == null">New</td>
                                            <td v-if="item.status == 'error'">Error Processing</td>
                                            <td >
                                                <router-link :to="'/finance/collection-retry/'+item.id" class="nav-link"> 
                                                    {{ item.batch_count }}
                                                </router-link>    
                                            </td>
                                            <td v-if="permissions.canExport?.value" >
                                                <button @click="downloadFile(item)" class="btn btn-secondary btn-sm" :disable="loadingUpload"><i class="ri-file-excel-2-line align-middle me-1"></i> Download File</button>
                                            </td>                   
                                        </tr>
                                    </tbody>
                                </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </Layout>
</template>